<template>
  <div class="subaru_download">
    <div class="subaru_download_box">
      <img class="download_bk_img" :src="img.download_bk">
      <a class="btn" id="to_appstore" href="https://apps.apple.com/cn/app/%E5%AF%8C%E5%A3%AB%E8%8C%83%E5%84%BF/id1599695905"></a>
      <img class="download_btn_img" v-if="isiOS" @click="openDownload" :src="img.download_btn">

      <img class="download_btn_img" v-else @click="download" :src="img.download_btn">
    </div>
    <div class="mask" v-if="isWechat"></div>
    <div class="mask_content" v-if="isWechat">
      <div style="text-align: left;font-size: 14px;">点击右上角按钮，然后在弹出的菜单中，点击在浏览器中打开，即可安装</div>
      <img class="right_top_arrow" :src="img.right_top_arrow">
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { Dialog } from "vant";
  import content from '../../api/content';
  export default {
    data () {
      return {
        isAndroid:false,
        isiOS:false,
        isWechat:false,
        updateStatus:'',
        updateUrl:'',
        updateText:'',
        img:{
          subaru_logo:require('../../assets/img/subaruf.png'),
          lexus_logo:require('../../assets/img/lexus.png'),
          motortime_logo:require('../../assets/img/motortimelogo.png'),
          right_top_arrow:require('../../assets/img/right_top_arrow.png'),
          download_bk:require('../../assets/img/subaru/download_bk.png'),
          download_btn:require('../../assets/img/subaru/download_btn.png'),
        },
      }
    },
    
    created () {
      this.getNewVersion()
      this.$store.commit('param/show', false)
      let source = this.$route.params.source
      var u = navigator.userAgent, app = navigator.appVersion;
      var ua = window.navigator.userAgent.toLowerCase();
      this.isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; 
      this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if(ua.match(/MicroMessenger/i) == 'micromessenger' || ua.match(/_SQ_/i) == '_sq_'){
        this.isWechat=true
      }else{
        if(this.isiOS){
          Dialog.confirm({
            message:
            '即将打开App Store，下载富士范儿',
            confirmButtonColor:'#576B95'
          })
          .then(() => {
            var obj=document.getElementById('to_appstore')
            obj.click()
          })
          .catch(() => {
          });
        }else{
          var that=this
          window.setTimeout(function() {
            window.location = that.updateUrl?that.updateUrl:'https://pic.motortime.com/video/__/UN/__UNI__6040791_0109142503.apk'; 
          }, 1000);
        }
      }
    },
    methods: {
      getNewVersion(){
        content.getNewVersion({
          source: 20,
          version: 1.0
        }).then(res => {
          if(res.data.state == 1) {
            console.log(res)
            this.updateStatus = res.data.data.status
            this.updateUrl = res.data.data.url
            this.updateText = res.data.data.content
          }
        })
      },
      openDownload(){
       Dialog.confirm({
        message:
        '即将打开App Store，下载富士范儿',
        confirmButtonColor:'#576B95'
      })
       .then(() => {
        var obj=document.getElementById('to_appstore')
        obj.click()
      })
       .catch(() => {
       });
     },
     download(){
      var that=this
      window.setTimeout(function() {
        window.location = that.updateUrl?that.updateUrl:'https://pic.motortime.com/video/__/UN/__UNI__6040791_0109142503.apk'; 
      }, 500);
    },
  },
  components: {
    [Dialog.name]: Dialog
  }
};
</script>

<style lang="scss">
.subaru_download {
  .btn{
    color: #ffffff;
    font-size: 12px;
    margin-top: 50px;
    background-color: #12b7f5;
    padding: 15px 0;
    border-radius:3px;
    margin: 80px 15%;

  }
  .subaru_download_box{
    width: 100%;
    height: 100vh;
    position: relative;
    overflow: hidden;
    text-align: center;
    .download_bk_img{
      width: 100%;
      height: 100vh;
      object-fit:cover;
    }
    .download_btn_img{
      width: 100px;
      height: 35px;
      position: absolute;
      top: 88%;
      left: 0;
      right: 0;
      margin: 0 auto;
    }
  }
  .mask{
    position:fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom:0;
    background-color:rgba(0,0,0,.3);
    z-index: 999;
  }
  .mask_content{
    color: #ffffff;
    position:fixed;
    top: 15px;
    left: 15px;
    right: 35px;
    z-index: 1000;
    display: flex;
    align-items:flex-start;
  }
  .right_top_arrow{
    width: 40px;
    height: 40px;
  }
}
</style>
